<template>
    <div class="font-14" style="height: 480px">
        <loader object="#df3e46" v-show="progressAtividade" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
        <div class="card">
            <div class="p-2">
                <div class="row">
                    <div class="col-9">
                        <div class="col text-bold-6">
                            <span style="font-size: 14px" class="ml--2">Atividade</span> - <span style="font-size: 14px" :class="'situacao-'+ atividade.situacao">{{atividade.codigo}}</span>
                        </div>
                        <div class="col">
                            <div class="text-bold-6 ml--2" style="height: 50px;">
                                <el-tooltip v-if="atividade.destaque" 
                                        content="Atividade em destaque" placement="top">
                                    <i class="text-warning fas fa-star mr-1"></i>
                                </el-tooltip>
                                <el-tooltip :content="atividade.titulo" placement="top">
                                    <span style="font-size: 18px" :class="'situacao-'+ atividade.situacao">{{ (atividade.titulo || '').trim().substring(0, 180) }}{{ (atividade.titulo || '').length > 180 ? "..." : "" }}</span>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                    <div class="col-3 mt-1 text-bold-6">
                        <div>
                            Situação
                        </div>
                        <div :class="'situacao-'+ atividade.situacao">
                            {{atividade.situacaoDescricao}}
                        </div>
                    </div>
                </div>

                <ul class="nav nav-tabs mt-2 bg-light text-bold-6" id="tabAtividade" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link" id="tab-atividade-projeto-link" data-toggle="tab" href="#atividade-projeto" role="tab" 
                            aria-controls="atividade-projeto" aria-selected="false">
                            Projeto
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link active" id="tab-atividade-dados-link" data-toggle="tab" href="#atividade-dados" role="tab" 
                        aria-controls="atividade-dados" aria-selected="true">
                            Atividade
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="tab-atividade-tarefas-link" data-toggle="tab" href="#atividade-tarefas" role="tab" 
                        aria-controls="atividade-tarefas" aria-selected="false">
                            Tarefas
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="tab-atividade-obs-link" data-toggle="tab" href="#atividade-obs" role="tab" 
                        aria-controls="atividade-obs" aria-selected="false">
                            Observações
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="tab-atividade-historico-link" data-toggle="tab" href="#atividade-historico" role="tab" 
                        aria-controls="atividade-historico" aria-selected="false">
                            Histórico
                        </a>
                    </li>
                </ul>
                <div class="tab-content mt-3" style="height: 325px;" id="tabAtividadeContent">
                    
                    <!-- Projeto  -->
                    <div class="container mt-2 tab-pane fade show" id="atividade-projeto" role="tabpanel" aria-labelledby="tab-atividade-projeto-link" v-if="atividade.projeto">
                        
                        <div class="row mt-2">
                            <div class="col-10 text-bold-6">
                                <div>
                                    Projeto - {{atividade.projeto.codigo}}
                                </div>
                                <div>
                                    <span :class="'situacao-'+ atividade.projeto.situacao" 
                                            class="clickable" @click="abrirModalProjeto(atividade.projeto)">
                                        {{atividade.projeto.titulo}}<i class="fas fa-link ml-3"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="col-2 text-bold-6">
                                <div>
                                    Situação
                                </div>
                                <div :class="'situacao-'+ atividade.projeto.situacao">
                                    {{atividade.projeto.situacaoDescricao}}
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div :class="(situacaoProjeto('EMANDAMENTO')) ? 'col-4' : 'col-6'">
                                <div class="text-bold-6">
                                    Data Início e Fim
                                </div>
                                <div :class="(atividade.projeto.reagendado) ? 'font-reagenda' : ''">
                                    {{atividade.projeto.dataInicio}} até {{atividade.projeto.dataFim}}
                                </div>
                            </div>
                            <div :class="(situacaoProjeto('EMANDAMENTO')) ? 'col-2' : 'col-3'">
                                <div class="text-bold-6">
                                    Investimento
                                </div>
                                <div>
                                    {{atividade.projeto.investimentoFmt}}
                                </div>
                            </div>
                            <div class="col-2" v-if="situacaoProjeto('NAOINICIADO')">
                                <div class="text-bold-6">
                                    Início
                                </div>
                                <div>
                                    {{atividade.projeto.inicio}}
                                </div>                             
                            </div>
                            <div class="col-4" v-if="situacaoProjeto('EMANDAMENTO')">
                                <div class="text-bold-6">
                                    Progresso
                                </div>
                                <div>
                                    <div class="progress mt-1">
                                        <div class="progress-bar" role="progressbar" 
                                            :style="'font-size: 11px; width: '+ atividade.projeto.progresso +'%;'"
                                            :class="'progresso-'+ atividade.projeto.situacao">
                                            {{atividade.projeto.progresso}}%
                                        </div>  
                                    </div>                                
                                </div>
                            </div>
                            <div class="col-1" v-if="atividade.projeto.termino!='0'">
                                <div class="text-bold-6">
                                    Término
                                </div>
                                <div>
                                    {{atividade.projeto.termino}}
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6">
                                <div class="text-bold-6">
                                    Criador por
                                </div>
                                <div class="row">
                                    <div class="col-1" v-if="atividade.projeto && atividade.projeto.criador && atividade.projeto.criador.avatar">
                                        <img :src="atividade.projeto.criador.avatar" :title="atividade.projeto.criador.nome" width="27" class="rounded-circle ml-2 mr-2">
                                    </div>
                                    <div class="col ml-3 mt-1">
                                        {{ (atividade.projeto && atividade.projeto.criador && atividade.projeto.criador.apelido) ? atividade.projeto.criador.apelido : '-' }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="text-bold-6">
                                    Classificação
                                </div>
                                <div>
                                    {{atividade.projeto.classificacaoDescricao}}
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="text-bold-6">
                                    Relevância
                                </div>
                                <div>
                                    {{atividade.projeto.relevanciaDescricao}}
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6">
                                <div class="text-bold-6">
                                    Responsáveis
                                </div>
                                <div class="listaResponsavelProjeto">
                                    <div v-for="resp in (atividade.projeto && atividade.projeto.listaResponsavel) ? atividade.projeto.listaResponsavel : []" :key="resp.idusuario">
                                        <div class="row">
                                            <div class="col-1">
                                                <img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle ml-2 mr-2">
                                            </div>
                                            <div class="col ml-3 mt-1">
                                                {{resp.apelido}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="text-bold-6">
                                    Grupo de Trabalho
                                </div>
                                <div class="listaResponsavelProjeto">
                                    <div v-for="gt in (atividade.projeto && atividade.projeto.listaGrupoTrabalho) ? atividade.projeto.listaGrupoTrabalho : []" :key="gt.idgt">
                                        - {{gt.nome}}<br/>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </div>

                    <!-- Atividade  -->
                    <div class="container mt-1 tab-pane fade show active" id="atividade-dados" role="tabpanel" aria-labelledby="tab-atividade-dados-link">
                        
                        <div class="row menuOpcao mb-2">
                            <div class="col-12 text-right">
                                <el-tooltip 
                                        v-if="exibirOpcaoAtividade()"
                                        content="Reagendar" placement="top">
                                    <i 
                                        @click="modalReagendarAtividade()"
                                        class="fas fa-calendar-alt icones iconeReagendar"></i>
                                </el-tooltip>
   
                                <el-tooltip 
                                        v-if="exibirOpcaoAtividade()"
                                        content="Alterar" placement="top">
                                    <i 
                                        @click="alterarAtividade()"
                                        class="fas fa-edit ml-3 icones iconeAlterar"></i>
                                </el-tooltip>
                                <el-tooltip 
                                    v-if="exibirOpcaoAtividade()"
                                    content="Cancelar" placement="top">
                                    <i 
                                        @click="modalCancelarAtividade()"
                                        class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
                                </el-tooltip>
                                <el-tooltip 
                                    v-if="exibirOpcaoAtividade()"
                                    content="Concluir" placement="top">
                                    <i 
                                        @click="concluirAtividade()"
                                        class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
                                </el-tooltip>
                                <el-tooltip 
                                    v-if="exibirOpcaoExcluirAtividade()"
                                    content="Excluir" placement="top">
                                    <i @click="excluirAtividade()"
                                        class="fa fa-trash ml-3 icones iconeCancelar"></i>
                                </el-tooltip>
                            </div>
                        </div>
                        <div class="row mt-1">
                            <div :class="(situacaoAtividade('EMANDAMENTO')) ? 'col-5' : (situacaoAtividade('NAOINICIADA')) ? 'col-5' : 'col-5'">
                                <div class="text-bold-6">
                                    Data Início e Fim
                                </div>
                                <div v-if="!modals.modalReagendarAtividade" 
                                    :class="(atividade.reagendada) ? 'font-reagenda' : ''">
                                    {{atividade.dataInicio}} até {{atividade.dataFim}}
                                    <el-tooltip 
                                            class="ml-2"
                                            v-if="exibirOpcaoAtividade()"
                                            content="Reagendar" placement="top">
                                        <i 
                                            @click="modalReagendarAtividade()"
                                            class="fas fa-calendar-alt icones iconeReagendar"></i>
                                    </el-tooltip>
                                </div>
                                <div class="row" v-if="modals.modalReagendarAtividade">
                                    <div class="col-5">
                                        <flat-picker
                                            value=""
                                            tabindex="3"
                                            id="dataInicio"
                                            class="form-control datepicker mb-2"
                                            placeholder="Data Início"
                                            v-model="atividade.dataInicio"
                                            :config="{
                                                allowInput: true,
                                                minDate: new Date(projeto.dataInicioYMD),
                                                maxDate: new Date(projeto.dataFimYMD),
                                                dateFormat: 'd/m/Y',
                                                altFormat: 'M j, Y',
                                            }"/>
                                    </div>
                                    <div class="col-5">
                                        <flat-picker
                                            value=""
                                            tabindex="3"
                                            id="dataFim"
                                            class="form-control datepicker mb-2 ml-n2"
                                            placeholder="Data Fim"
                                            v-model="atividade.dataFim"
                                            :config="{
                                                allowInput: true,
                                                minDate: atividade.dataInicio,
                                                maxDate: new Date(projeto.dataFimYMD),
                                                dateFormat: 'd/m/Y',
                                                altFormat: 'M j, Y',
                                            }"/>
                                    </div>
                                    <div class="col-2 mt-2">
                                        <el-tooltip content="Reagendar" placement="top">
                                            <i 
                                                @click="reagendarAtividade()"
                                                class="fas fa-check-circle ml-n2 text-success icones"></i>
                                        </el-tooltip>
                                        <el-tooltip content="Desistir" placement="top">
                                            <i 
                                                @click="fecharModalReagendarAtividade()"
                                                class="fas fa-times ml-2 text-danger icones"></i>
                                        </el-tooltip>
                                    </div>
                                </div>
                            </div>
                            <div :class="(situacaoAtividade('EMANDAMENTO')) ? 'col-4' : 'col-4'">
                                <div class="text-bold-6">
                                    Investimento {{ (atividade.investimentoNaoEmpenho > 0) ? '/ Não Empenhado' : ''}}
                                </div>
                                <div>
                                    {{atividade.investimentoFmt}} {{(atividade.investimentoNaoEmpenho > 0) ? '/ '+ atividade.investimentoNaoEmpenhoFmt : ''}}
                                </div>
                            </div>
                            <div class="col-2" v-if="situacaoAtividade('NAOINICIADA')">
                                <div class="text-bold-6">
                                    Início
                                </div>
                                <div>
                                    {{atividade.inicio}}
                                </div>                             
                            </div>
                            <div class="col-2" v-if="situacaoAtividade('ATRASADA')">
                                <div class="text-bold-6">
                                    Atrasada
                                </div>
                                <div :class="'situacao-'+ atividade.situacao">
                                    {{atividade.atrasada}}
                                </div>
                            </div>
                            <div class="col-3" v-if="situacaoAtividade('EMANDAMENTO')">
                                <div class="text-bold-6">
                                    Progresso
                                </div>
                                <div>
                                    <div class="progress mt-1">
                                        <div class="progress-bar" role="progressbar" 
                                            :style="'font-size: 11px; width: '+ atividade.progresso +'%;'"
                                            :class="'progresso-'+ atividade.situacao">
                                            {{atividade.progresso}}%
                                        </div>     
                                    </div>                                
                                </div>
                            </div>
                            <div v-if="exibirOpcaoAtividade() && atividade.termino!='0'" class="col-2">
                                <div class="text-bold-6">
                                    Término
                                </div>
                                <div>
                                    {{atividade.termino}}
                                </div>
                            </div>
                            <div v-if="situacaoAtividade('CONCLUIDA')" class="col-3">
                                <div class="text-bold-6">
                                    Data de conclusão
                                </div>
                                <div :class="'situacao-'+ this.atividade.situacao">
                                    {{this.atividade.dataConclusao}}
                                </div>
                            </div>
                            <div v-if="situacaoAtividade('CANCELADA')" class="col-3">
                                <div class="text-bold-6">
                                    Data de cancelamento
                                </div>
                                <div :class="'situacao-'+ this.atividade.situacao">
                                    {{this.atividade.dataConclusao}}
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-5">
                                <div class="text-bold-6">
                                    Responsável(is)
                                </div>
                                <div class="listaResponsavelProjeto">
                                    <div v-for="resp in atividade.listaResponsavel" :key="resp.idusuario">
                                        <div class="row">
                                            <div class="col-1">
                                                <img :src="resp.avatar" :title="resp.nome" width="27" class="rounded-circle ml-2 mr-2">
                                            </div>
                                            <div class="col ml-3 mt-1">
                                                {{resp.apelido}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4" v-if="atividade.criador">
                                <div class="text-bold-6">
                                    Criado por
                                </div>
                                <div class="row">
                                    <div class="col-1">
                                        <img :src="atividade.criador.avatar" :title="atividade.criador.nome" width="27" class="rounded-circle ml-2 mr-2">
                                    </div>
                                    <div class="col ml-3 mt-1">
                                        {{atividade.criador.apelido}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="text-bold-6">
                                    Tipo
                                </div>
                                <div>
                                    {{atividade.tipoDescricao}}
                                </div>
                            </div>
                        </div>
                    
                    </div>

                    <!-- Tarefas  -->
                    <div class="container mt-2 tab-pane fade show" id="atividade-tarefas" role="tabpanel" aria-labelledby="tab-atividade-tarefas-link">
                        
                        <div class="row mt-1">
                            <div class="col-4" v-if="exibirOpcaoAtividade()">

                                <div>
                                    <div class="ml-1 text-bold-6">
                                        Cadastro de Tarefa
                                    </div>
                                    <div class="p-1 text-bold-6">
                                        <input
                                            id="inputTitulo"
                                            maxlength="100"
                                            tabindex="1"
                                            type="text"
                                            class="form-control mb-2"
                                            v-model="tarefa.titulo"
                                            placeholder="Nome da Tarefa"
                                        />
                                    </div>
                                    <div class="p-1 row">
                                        <div class="col">
                                            <flat-picker
                                                value=""
                                                tabindex="3"
                                                id="dataInicio"
                                                class="form-control datepicker mb-2"
                                                v-model="tarefa.dataInicio"
                                                placeholder="Data Início"
                                                :config="{
                                                    allowInput: true,
                                                    minDate: this.atividade.dataInicio,
                                                    maxDate: this.atividade.dataFim,
                                                    dateFormat: 'd/m/Y',
                                                    altFormat: 'M j, Y',
                                                }"/>
                                        </div>
                                        <div class="col">
                                            <flat-picker
                                                value=""
                                                tabindex="3"
                                                id="dataFim"
                                                class="form-control datepicker mb-2"
                                                v-model="tarefa.dataFim"
                                                placeholder="Data Fim"
                                                :config="{
                                                    allowInput: true,
                                                    minDate: this.tarefa.dataInicio,
                                                    maxDate: this.atividade.dataFim,
                                                    dateFormat: 'd/m/Y',
                                                    altFormat: 'M j, Y',
                                                }"/>
                                        </div>
                                    </div>

                                    <div class="text-right">
                                        <button
                                            type="button"
                                            tabindex="9"
                                            class="btn btn-light btn-sm"
                                            @click="limparTarefa()">
                                            <i class="fas fa-eraser mr-2"></i>
                                            Limpar
                                        </button>
                                        <button
                                            type="button"
                                            tabindex="9"
                                            class="btn btn-success btn-sm"
                                            @click="salvarTarefa()">
                                            <i class="far fa-check-circle mr-2"></i>
                                            {{botaoTarefa}}
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div :class="(exibirOpcaoAtividade()) ? 'col-8' : 'col-12'"> 
                                
                                <div class="row text-center">
                                    <div class="col-1 p-0">

                                    </div>
                                    <div class="col p-0 mr-1 filtroTarefa" 
                                        :class="'filtroNI'+ sitFiltroTarefa.NI"
                                        @click="filtraTarefaNI">
                                        Não Iniciada
                                    </div>
                                    <div class="col p-0 mr-1 filtroTarefa" 
                                        :class="'filtroEA'+ sitFiltroTarefa.EA"
                                        @click="filtraTarefaEA">
                                        Em Andamento
                                    </div>
                                    <div class="col p-0 mr-1 filtroTarefa" 
                                        :class="'filtroAT'+ sitFiltroTarefa.AT"
                                        @click="filtraTarefaAT">
                                        Atrasada
                                    </div>
                                    <div class="col p-0 mr-1 filtroTarefa" 
                                        :class="'filtroCO'+ sitFiltroTarefa.CO"
                                        @click="filtraTarefaCO">
                                        Concluída
                                    </div>
                                    <div class="col p-0 filtroTarefa" 
                                        :class="'filtroCA'+ sitFiltroTarefa.CA"
                                        @click="filtraTarefaCA">
                                        Cancelada
                                    </div>
                                    <div class="col-1 p-0">

                                    </div>
                                </div>
                                <div class="listaAtividade p-2 text-justify">

                                    <div class="mt-2 text-center" v-if="listaTarefa.length == 0">
                                        Nenhuma tarefa encontrada
                                    </div>
                                    <div class="mb-1 px-2 py-1 atividadeIndividual linhaSeparacao" 
                                            v-for="tarefa in listaTarefa" :key="tarefa.idtarefa">

                                        <div class="row text-bold-6">
                                            <div class="col d-flex align-content-center flex-wrap">
                                                <div class="col-12 text-right">
                                                    <el-tooltip 
                                                        v-if="situacaoNaoCACOTarefa(tarefa)"
                                                        content="Alterar" placement="top">
                                                        <i 
                                                            @click="alterarTarefa(tarefa)"
                                                            class="fas fa-edit ml-3 icones iconeAlterar"></i>
                                                    </el-tooltip>
                                                    <el-tooltip content="Copiar" placement="top">
                                                        <i 
                                                            @click="copiarTarefa(tarefa)"
                                                            class="far fa-copy ml-3 icones iconeReagendar"></i>
                                                    </el-tooltip>
                                                    <el-tooltip 
                                                        v-if="situacaoNaoCACOTarefa(tarefa)"
                                                        content="Cancelar" placement="top">
                                                        <i 
                                                            @click="modalCancelarTarefa(tarefa)"
                                                            class="far fa-calendar-times ml-3 icones iconeCancelar"></i>
                                                    </el-tooltip>
                                                    <el-tooltip 
                                                        v-if="situacaoNaoCACOTarefa(tarefa)"
                                                        content="Concluir" placement="top">
                                                        <i 
                                                            @click="concluirTarefa(tarefa)"
                                                            class="fas fa-calendar-check ml-3 icones iconeConcluir"></i>
                                                    </el-tooltip>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row text-bold-6">
                                            <div class="col-2 mt--4">
                                                <span :class="'titulo-'+ tarefa.situacao">
                                                    {{ tarefa.codigo }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="row text-bold-6">
                                            <div class="col">
                                                <span :class="'titulo-'+ tarefa.situacao">
                                                    {{ tarefa.titulo }}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="row mt-1">
                                            <div class="col-7">
                                                <div class="text-bold-6">
                                                    Período
                                                </div>
                                                <div :class="(tarefa.reagendada) ? 'font-reagenda' : ''">
                                                    {{tarefa.dataInicio}} até {{tarefa.dataFim}}
                                                </div>
                                            </div>
                                            <div class="col-5" v-if="situacaoNITarefa(tarefa)">
                                                <div class="text-bold-6">
                                                    Início
                                                </div>
                                                <div>
                                                    {{tarefa.inicio}}
                                                </div>                             
                                            </div>
                                            <div class="col-5 text-bold-6" v-if="situacaoEATarefa(tarefa)">
                                                Progresso
                                                <div class="progress" style="height: 10px;">
                                                    <div class="progress-bar" role="progressbar" 
                                                        :style="'font-size: 11px; width: '+ tarefa.progresso +'%;'"
                                                        :class="'progresso-'+ tarefa.situacao">
                                                        {{tarefa.progresso}}%
                                                    </div>
                                                </div>                                
                                            </div>
                                            <div class="col-5" v-if="tarefa.situacao=='ATRASADA'">
                                                <div class="text-bold-6">
                                                    Atrasada
                                                </div>
                                                <div :class="'situacao-'+ tarefa.situacao">
                                                    {{tarefa.atrasada}}
                                                </div>
                                            </div>
                                            <div class="col-5" v-if="tarefa.situacao=='CONCLUIDA'">
                                                <div class="text-bold-6">
                                                    Data de conclusão
                                                </div>
                                                <div :class="'situacao-'+ tarefa.situacao">
                                                    {{tarefa.dataConclusao}}
                                                </div>
                                            </div>
                                            <div class="col-5" v-if="tarefa.situacao=='CANCELADA'">
                                                <div class="text-bold-6">
                                                    Data de cancelamento
                                                </div>
                                                <div :class="'situacao-'+ tarefa.situacao">
                                                    {{tarefa.dataConclusao}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-1 mb-3">
                                            <div class="col-7">
                                                <div class="text-bold-6">
                                                    Criador por
                                                </div>
                                                <div class="row">
                                                    <div class="col-1">
                                                        <img :src="tarefa.criador.avatar" :title="tarefa.criador.nome" width="27" class="rounded-circle ml-2 mr-2">
                                                    </div>
                                                    <div class="col ml-3 mt-1">
                                                        {{tarefa.criador.apelido}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-5">
                                                <div class="text-bold-6">
                                                    Situação
                                                </div>
                                                <div :class="'situacao-'+ tarefa.situacao">
                                                    {{tarefa.situacaoDescricao}}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    
                                </div>
                            </div>

                        </div>

                    </div>

                    <!-- Observações  -->
                    <div class="container mt-2 tab-pane fade show" id="atividade-obs" role="tabpanel" aria-labelledby="tab-atividade-obs-link">
                     
                        <div class="row mt-1">
                            <div class="col-4">
                                <div class="ml-1 text-bold-6">
                                    Cadastro de Observação
                                </div>
                                <div class="text-bold-6">
                                    <textarea rows="3" 
                                        v-model="observacao.descricao"
                                        class="form-control mb-2"
                                        maxlength="1000"
                                        placeholder="Preencha a observação"></textarea>
                                </div>
                                <div class="text-right">
                                    <button
                                        type="button"
                                        tabindex="9"
                                        class="btn btn-light btn-sm"
                                        @click="limparObservacao()">
                                        <i class="fas fa-eraser mr-2"></i>
                                        Limpar
                                    </button>
                                    <button
                                        type="button"
                                        tabindex="9"
                                        class="btn btn-success btn-sm"
                                        @click="salvarObservacao()">
                                        <i class="far fa-check-circle mr-2"></i>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                            <div class="col-8"> 

                                <div class="listaAtividade p-2 text-justify">
                                    
                                    <div class="mt-2 text-center" v-if="listaObservacao.length == 0">
                                        Nenhuma observação cadastrada
                                    </div>
                                    <div class="mb-3 linhaSeparacao" v-for="obs in listaObservacao" :key="obs.idatividadeobservacao">
                                        <div class="mb-2 ml-2">
                                            {{ obs.descricao }}
                                        </div>
                                        <div class="row mb-1">
                                            <div class="col-6">
                                                <div class="row">
                                                    <div class="col-1">
                                                        <img :src="obs.criador.avatar" :title="obs.criador.nome" width="27" class="rounded-circle ml-2 mr-2">
                                                    </div>
                                                    <div class="col ml-4 mt-1">
                                                        {{ obs.criador.apelido }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-6 text-right font-13 mt-1">
                                                {{ obs.dataAlteracao }} - {{ obs.tempoDataHora }}
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>
                        </div>

                    </div>

                    <!-- Histórico  -->
                    <div class="container mt-2 tab-pane fade show" id="atividade-historico" role="tabpanel" aria-labelledby="tab-atividade-historico-link">
                     
                        <div class="listaAtividade p-2 text-justify">

                            <div class="mt-2 text-center" v-if="listaHistorico.length == 0">
                                Nenhum histórico registrado
                            </div>
                            <div class="mb-3 linhaSeparacao" v-for="historico in listaHistorico" :key="historico.idatividadehistorico">
                                <div class="mb-1 ml-2">
                                    <i :class="historico.tipoIcone +` mr-1 icones font-13`"></i> <strong>{{ historico.titulo }}</strong> &nbsp; {{ historico.tempoDataHora }}<br/>
                                    {{ historico.descricao }}
                                </div>
                                <div class="row mt-2 mb-1">
                                    <div class="col-6">
                                        <div class="row">
                                            <div class="col-1">
                                                <img :src="historico.criador.avatar" :title="historico.criador.nome" width="27" class="rounded-circle ml-2 mr-2">
                                            </div>
                                            <div class="col ml-3 mt-1">
                                                {{ historico.criador.apelido }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 text-right font-13">
                                        {{ historico.dataAlteracao }}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal :show.sync="modals.modalCancelarTarefa">
            <loader object="#df3e46" v-if="progressTarefaCancelar" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
            <form class="ml-3 mt-3 mr-3 mb-3">
                <h4 class="text-center">Cancelar Tarefa</h4>
                <div class="row">

                    <div class="col">
                        <label for="inputTitulo">
                            Justificativa do cancelamento
                            <el-tooltip content="Campo obrigatório" placement="top">
                                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                            </el-tooltip>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend mb-2">
                                <span class="input-group-text"><i class="fas fa-align-left"></i></span>
                            </div>
                            <textarea rows="2" 
                                v-model="tarefaCancelar.justificativa"
                                class="form-control mb-2"
                                maxlength="200"
                                placeholder="Preencha a justificativa"></textarea>
                        </div>
                    </div>
                </div>
                <br class="clear" />
                <div class="row">
                    <div class="col text-center mt-3">
                        <button type="button" 
                                @click="fecharModalCancelarTarefa()"
                                class="btn btn-danger mr-3">
                            Desistir
                        </button>
                        <button type="button" 
                                @click="cancelarTarefa()"
                                class="btn btn-success ml-3">
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </modal>

        <modal :show.sync="modals.modalCancelarAtividade">
            <loader object="#df3e46" v-show="progressAtividadeCancelar" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
            <form class="ml-3 mt-3 mr-3 mb-3">
                <h4 class="text-center">Cancelar Atividade</h4>
                <div class="row">

                    <div class="col">
                        <label for="inputTitulo">
                            Justificativa do cancelamento
                            <el-tooltip content="Campo obrigatório" placement="top">
                                <i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                            </el-tooltip>
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend mb-2">
                                <span class="input-group-text"><i class="fas fa-align-left"></i></span>
                            </div>
                            <textarea rows="2" 
                                v-model="atividadeCancelar.justificativa"
                                class="form-control mb-2"
                                maxlength="200"
                                placeholder="Preencha a justificativa"></textarea>
                        </div>
                    </div>
                </div>
                <br class="clear" />
                <div class="row">
                    <div class="col text-center mt-3">
                        <button type="button" 
                                @click="fecharModalCancelarAtividade()"
                                class="btn btn-danger mr-3">
                            Desistir
                        </button>
                        <button type="button" 
                                @click="cancelarAtividade()"
                                class="btn btn-success ml-3">
                            Salvar
                        </button>
                    </div>
                </div>
            </form>
        </modal>       

    </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    name: 'Atividade',
    props: ['atividadeSelecionada'],
	components: {
		flatPicker
	},
	created() {
		this.carregarListaAtividade();
	},
	data() {
        const atividadeInicial = this.atividadeSelecionada || {};
		const projetoInicial = Object.assign({ criador: {} }, atividadeInicial.projeto || {});
		return {
            atividade: Object.assign({
                titulo: '',
                projeto: { criador: {} },
            }, atividadeInicial),
            projeto: projetoInicial,
			progressAtividade: true,
			progressTarefaCancelar: false,
			progressAtividadeCancelar: false,
            tarefa: {},
            observacao: {},
            sitFiltroTarefa: {
                NI: true,
                EA: true,
                AT: true,
                CO: true,
                CA: true,
            },
			listaTarefa: [],
			listaTarefaFitro: [],
			listaObservacao: [],
			listaHistorico: [],
            botaoTarefa: "Salvar",
            tarefaCancelar: {},
            atividadeCancelar: {},
            modals: {
                modalReagendarAtividade: false,
                modalCancelarAtividade: false,
                modalCancelarTarefa: false,
                modalProjeto: false,
            },
			projetoModal: null,
		};
	},
	methods: {
		carregarListaAtividade() {

			this.$clubApi.get("/atividade/carregar/"+ this.atividade.idatividade).then((response) => {
                
                // ATIVIDADE
                this.atividade = response.data.object.atividade;
                this.projeto = this.atividade.projeto;
                // TAREFA
				this.listaTarefa = response.data.object.listaTarefa;
				this.listaTarefaFitro = response.data.object.listaTarefa;
                this.tarefa = {
                    //dataInicio: this.atividade.dataInicio,
                    //dataFim: this.atividade.dataFim,
                    idatividade: this.atividade.idatividade
                };
                this.selecionarFiltroTarefa();
                this.filtrarTarefa();
                // OBS
				this.listaObservacao = response.data.object.listaObservacao;
                // HISTORICO
				this.listaHistorico = response.data.object.listaHistorico;
			})
            .catch((error) => {
                this.$toastr.error(error.response.data.msg);
            })
            .finally(() => {
                this.progressAtividade = false;
            });
        },
        atualizarListagem() {
            this.$emit('atualizar-lista', {});
        },
        selecionarFiltroTarefa() {
            if (this.situacaoAtividade('CANCELADA')) {
                this.sitFiltroTarefa = {
                    NI: false,
                    EA: false,
                    AT: false,
                    CO: true,
                    CA: true,
                }
            }      
        },

        // - PROJETO
        situacaoProjeto(situacao) {
            return this.atividade.projeto.situacao == situacao;
        },

        // - ATIVIDADE
        modalReagendarAtividade() {
            this.modals.modalReagendarAtividade = true;
        },
        fecharModalReagendarAtividade() {
            this.modals.modalReagendarAtividade = false;
        },
        reagendarAtividade() {
			if (confirm('Deseja realmente REAGENDAR a Atividade?')) {
                this.progressAtividade = true;
                this.$clubApi.post("/atividade/reagendar", this.atividade).then(() => {
                    this.carregarListaAtividade();
                    this.modals.modalReagendarAtividade = false;
                    this.atualizarListagem();
                    this.$toastr.success("Atividade reagendada com sucesso!");
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progressAtividade = false;
                });
            }
        },
        alterarAtividade(){
            location.href = '/atividade-cadastro/'+ this.atividade.idatividade;
        },
        incluirAtividade(){
            location.href = '/atividade-cadastro';
        },
        modalCancelarAtividade() {
            this.atividadeCancelar.justificativa = null;
            this.atividadeCancelar = this.atividade;
            this.modals.modalCancelarAtividade = true;
        },
        fecharModalCancelarAtividade() {
            this.modals.modalCancelarAtividade = false;
        },
        cancelarAtividade() {
            if (this.validaAtividadeCancelar()) {
				if (confirm('Deseja realmente CANCELAR essa Atividade?\n\nTodas as tarefas relacionadas à essa atividade serão canceladas')) {
                    this.progressAtividadeCancelar = true;
                    this.$clubApi.post("/atividade/cancelar", this.atividadeCancelar).then(() => {
                        //this.limparAtividade();
                        this.carregarListaAtividade();
                        this.atividadeCancelar.justificativa = null;
                        this.atividadeCancelar = {};
                        this.modals.modalCancelarAtividade = false;
                        this.atualizarListagem();
                        this.$toastr.success("Atividade cancelada com sucesso!");
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                    })
                    .finally(() => {
                        this.progressAtividadeCancelar = false;
                    });
                }
            }
        },
		validaAtividadeCancelar() {
			var camposValidos = true;
			if (this.atividadeCancelar.justificativa == null ||
                    this.atividadeCancelar.justificativa.trim() == "") {
				this.$toastr.error("Justificativa do cancelamento da Atividade obrigatória!");
				camposValidos = false;
			}
			return camposValidos;
		},
        concluirAtividade() {
			if (confirm('Deseja realmente CONCLUIR a Atividade:\n- '+ 
                    this.atividade.codigoNome +'\n\nTodas as tarefas relacionadas à essa atividade serão concluídas.')) {
                this.progressAtividade = true;
                this.$clubApi.post("/atividade/concluir", this.atividade).then(() => {
                    this.carregarListaAtividade();
                    this.atualizarListagem();
                    this.$toastr.success("Atividade concluída com sucesso!");
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progressAtividade = false;
                });
            }
        },
        excluirAtividade() {
			if (confirm('Deseja realmente EXCLUIR a Atividade:\n- '+ 
                    this.atividade.codigoNome +'\n\nTodas as tarefas relacionadas à essa atividade serão excluídas.')) {
                this.progressAtividade = true;
                this.$clubApi.post("/atividade/excluir", this.atividade).then(() => {
                    //this.carregarListaAtividade();
                    this.atualizarListagem();
                    this.$toastr.success("Atividade excluída com sucesso!");
                    this.$emit('fechar-atividade', {});
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progressAtividade = false;
                });
            }
        },
        exibirOpcaoAtividade() {
            return !(this.situacaoAtividade('CANCELADA') || this.situacaoAtividade('CONCLUIDA'));
        },
        exibirOpcaoExcluirAtividade() {
            return (localStorage.getItem("pnome") === "ADMIN");
        },
        situacaoAtividade(situacao) {
            return this.atividade.situacao == situacao;
        },

        // - TAREFA
        limparTarefa() {
            /*
            this.tarefa = {
                dataInicio: this.atividade.dataInicio,
                dataFim: this.atividade.dataFim,
                idatividade: this.atividade.idatividade
            };*/
            this.tarefa = {
                idatividade: this.atividade.idatividade
            };
            this.botaoTarefa = "Salvar";
        },
        salvarTarefa() {
            if (this.validaTarefa()) {
				let acao = (this.botaoTarefa === "Salvar") ? "incluir" : "alterar";
				let resposta = (this.botaoTarefa === "Salvar") ? "incluída" : "alterada";
				if (confirm('Deseja '+ acao +' a tarefa?')) {
                    this.progressAtividade = true;
                    this.tarefa.idatividade = this.atividade.idatividade;
                    this.$clubApi.post("/atividade/tarefa", this.tarefa).then(() => {
                        this.limparTarefa();
                        this.carregarListaAtividade();
                        this.$toastr.success("Tarefa "+ resposta +" com sucesso!");
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                        this.progressAtividade = false;
                    })
				}
            }
        },
		validaTarefa() {
			if (this.tarefa.dataFim == "") {
				this.$toastr.error("Data fim da Tarefa obrigatória!");
				return false;
			}
			if (this.tarefa.dataInicio == "") {
				this.$toastr.error("Data início da Tarefa obrigatória!");
				return false;
			}
			if (this.tarefa.titulo == null) {
				this.$toastr.error("Nome da Tarefa obrigatório!");
				return false;
			}
			return true;
		},
        alterarTarefa(tarefa) {
            let novaTarefa = {
                idtarefa: tarefa.idtarefa,
                dataInicio: tarefa.dataInicio,
                dataFim: tarefa.dataFim,
                titulo: tarefa.titulo
            }
            this.tarefa = novaTarefa;
            this.botaoTarefa = "Alterar";
        },
        copiarTarefa(tarefa) {
            let novaTarefa = {
                dataInicio: tarefa.dataInicio,
                dataFim: tarefa.dataFim,
                titulo: tarefa.titulo
            }
            this.tarefa = novaTarefa;
            this.botaoTarefa = "Salvar";
        },
        modalCancelarTarefa(tarefa) {
            this.tarefaCancelar.justificativa = null;
            this.tarefaCancelar = tarefa;
            this.modals.modalCancelarTarefa = true;
        },
        fecharModalCancelarTarefa() {
            this.modals.modalCancelarTarefa = false;
        },
        cancelarTarefa() {
            if (this.validaTarefaCancelar()) {
				if (confirm('Deseja realmente cancelar essa tarefa?')) {
                    this.progressTarefaCancelar = true;
                    this.$clubApi.post("/atividade/tarefa/cancelar", this.tarefaCancelar).then(() => {
                        this.limparTarefa();
                        this.carregarListaAtividade();
                        this.tarefaCancelar.justificativa = null;
                        this.tarefaCancelar = {};
                        this.modals.modalCancelarTarefa = false;
                        this.$toastr.success("Tarefa cancelada com sucesso!");
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                    })
                    .finally(() => {
                        this.progressTarefaCancelar = false;
                    });
                }
            }
        },
		validaTarefaCancelar() {
			var camposValidos = true;
			if (this.tarefaCancelar.justificativa == null ||
                    this.tarefaCancelar.justificativa.trim() == "") {
				this.$toastr.error("Justificativa do cancelamento da Tarefa obrigatória!");
				camposValidos = false;
			}
			return camposValidos;
		},
        concluirTarefa(tarefa) {
			if (confirm('Deseja realmente concluir a tarefa:\n- '+ tarefa.codigoNome +'?')) {
                this.tarefa = tarefa;
                this.progressAtividade = true;
                this.$clubApi.post("/atividade/tarefa/concluir", this.tarefa).then(() => {
                    this.limparTarefa();
                    this.carregarListaAtividade();
                    this.$toastr.success("Tarefa concluída com sucesso!");
                })
                .catch((error) => {
                    this.$toastr.error(error.response.data.msg);
                })
                .finally(() => {
                    this.progressAtividade = false;
                });
            }
        },
        situacaoNaoCACOTarefa(tarefa) {
            return !(tarefa.situacao == 'CANCELADA' || tarefa.situacao == 'CONCLUIDA');
        },
        situacaoNITarefa(tarefa) {
            return tarefa.situacao == 'NAOINICIADA';
        },
        situacaoEATarefa(tarefa) {
            return tarefa.situacao == 'EMANDAMENTO';
        },
        filtraTarefaNI() {
            this.sitFiltroTarefa.NI = !this.sitFiltroTarefa.NI;
            this.filtrarTarefa();
        },
        filtraTarefaEA() {
            this.sitFiltroTarefa.EA = !this.sitFiltroTarefa.EA;
            this.filtrarTarefa();
        },
        filtraTarefaAT() {
            this.sitFiltroTarefa.AT = !this.sitFiltroTarefa.AT;
            this.filtrarTarefa();
        },
        filtraTarefaCO() {
            this.sitFiltroTarefa.CO = !this.sitFiltroTarefa.CO;
            this.filtrarTarefa();
        },
        filtraTarefaCA() {
            this.sitFiltroTarefa.CA = !this.sitFiltroTarefa.CA;
            this.filtrarTarefa();
        },
        filtrarTarefa() {
            this.listaTarefa = this.listaTarefaFitro.filter((tarefa) => {
                return (
                    (this.sitFiltroTarefa.NI && tarefa.situacaoSigla=="NI") ||
                    (this.sitFiltroTarefa.EA && tarefa.situacaoSigla=="EA") ||
                    (this.sitFiltroTarefa.AT && tarefa.situacaoSigla=="AT") ||
                    (this.sitFiltroTarefa.CO && tarefa.situacaoSigla=="CO") ||
                    (this.sitFiltroTarefa.CA && tarefa.situacaoSigla=="CA")
                );
            })
        },
        // -- FIM TAREFA

        // -- OBSERVACAO 
        limparObservacao() {
            this.observacao = {};
        },
        salvarObservacao() {
            if (this.validaObservacao()) {

				//let acao = (this.observacao.idtarefa) ? "alterar" : "incluir";
				//let resposta = (this.observacao.idtarefa) ? "alterada" : "incluída";
                let acao = "incluir";
                let resposta = "incluída";
				if (confirm('Deseja '+ acao +' a observação?')) {
                    this.progressAtividade = true;
                    this.observacao.idatividade = this.atividade.idatividade;
                    this.$clubApi.post("/atividade/observacao", this.observacao).then(() => {
                        this.limparObservacao();
                        this.carregarListaAtividade();
                        this.$toastr.success("Observação "+ resposta +" com sucesso!");
                    })
                    .catch((error) => {
                        this.$toastr.error(error.response.data.msg);
                        this.progressAtividade = false;
                    });
				}
            }
        },
		validaObservacao() {
			var camposValidos = true;
			if (this.observacao.descricao == null) {
				this.$toastr.error("O campo Descrição é obrigatório!");
				camposValidos = false;
			}
			return camposValidos;
		},
		abrirModalProjeto(projeto) {
            this.$emit('fechar-atividade', {});
            this.$emit('abrir-projeto', projeto);
		},
    }
}
</script>
<style>
.clickable {
  cursor: pointer;
}
.clickable:hover {
  cursor: pointer;
  text-decoration: underline;
}
.text-bold-6 {
    font-weight: 600;
}
.font-14 {
    height: 430px;
    font-size: 14px;
}
.font-13 {
    font-size: 13px;
}
.menuOpcao {
    font-size: 14px;
    font-weight: 600;
    border-bottom: 1px dashed #808080;
}
.listaResponsavelProjeto {
    height: 110px;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: thin;          /* "auto" or "thin" */
}
.listaAtividade {
    height: 295px;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: thin;          /* "auto" or "thin" */
}
.atividadeIndividual:hover {
    background-color: #f0f0f0;
}
.semDetaque {
    color: #808080;
}
.comDetaque {
    color: gold;
}
.icones {
    color: #0f0044;
    color: #0db9d3;
    cursor: pointer;
    font-size: 17px;
}
.iconeCancelar:hover {
    color: red;
}
.iconeConcluir:hover {
    color: green;
}
.iconeAlterar:hover {
    color: #979700;
}
.iconeReagendar:hover {
    color: #0000ff;
}
.linhaSeparacao {
    border-bottom: 1px dashed #808080;
}
.titulo-CANCELADA {
    text-decoration: line-through;
}
.titulo-CONCLUIDA {
    color: #28a745;
}
.titulo-ATRASADA {
    color: #dc3545;
}
.situacao-CANCELADA {
    font-weight: 600;
    color: #dc3545;
}
.situacao-CONCLUIDA {
    font-weight: 600;
    color: #28a745;
}
.situacao-ATRASADA {
    font-weight: 600;
    color: #dc3545;
}
.progresso-ATRASADA {
    background-color: #dc3545;
}
.filtroTarefa {
    border: 1px solid #d8d8d8;
    border-radius: 10px;
    font-size: 10px;
    cursor: pointer;
}
.filtroTarefa:hover {
    border: 1px solid #525252;
    cursor: pointer;
}
.filtroNItrue {
    color: white;
    background-color: #808080;
}
.filtroNIfalse {
    color: #808080;
}
.filtroEAtrue {
    color: white;
    background-color: #17a2b8;
}
.filtroEAfalse {
    color: #17a2b8;
}
.filtroREtrue {
    color: white;
    background-color: #17a2b8;
}
.filtroREfalse {
    color: #17a2b8;
}
.filtroATtrue {
    color: white;
    background-color: #ff436cee;
}
.filtroATfalse {
    color: #ff436cee;
}
.filtroCAtrue {
    color: white;
    background-color: #ff436cee;
}
.filtroCAfalse {
    color: #ff436cee;
}
.filtroCOtrue {
    color: white;
    background-color: #42a842;
}
.filtroCOfalse {
    color: #42a842;
}
.font-reagenda {
    color: #b821bd;
    font-weight: 600;
}
.iconeFecharModal {
	position: absolute; 
	z-index: 1; 
	width: 96%; 
	color: darkred;
}
</style>